// Antd
import { Steps } from 'antd'

// Interfaces
import { IBaseStepsProps } from './interfaces'

// Components
import { BaseStep } from './BaseStep'

// UUID
import { v4 as uuidv4 } from 'uuid'

const BaseSteps = ({ current, onChange, steps, ...rest }: IBaseStepsProps) => {
  return (
    <Steps current={current} onChange={onChange} {...rest}>
      {steps.map(step => (
        <BaseStep {...step} key={uuidv4()} />
      ))}
    </Steps>
  )
}

export { BaseSteps }
